import { render } from "./Empty.vue?vue&type=template&id=3539bb5a"
const script = {}
script.render = render

export default script